<template>

<div class="fixed-widgets-avatar fixed-widgets" id="backButtom"  :style="{right:right,position:position}" @click="toBack"><!---->
      <div style="font-size: 12px;
    word-break: keep-all;" class="backText">{{ backText }}</div>

      <svg-icon className="back" name="撤销" mr="0"></svg-icon>
    </div>
</template>
<script setup>
import router from '@/router';
import { type } from 'jquery';
import { ref } from 'vue';
    const showPro =defineProps({
      right:{
        type:String,
        default:"120px"
      },
      position:{
        type:String,
        default:"fixed"
      }
    })
    const backText=ref( '返回' + '\n' + '上一页')
    const toBack = () => {
      router.back()
    }

</script>
<style lang="less" >
.back {
	margin-left: 32upx;
	width: 48upx;
	height: 48upx;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.fixed-widgets.fixed-widgets-avatar:hover .svg-icon {
  display: none;
}

.fixed-widgets.fixed-widgets-avatar:hover .backText {
  display: block;
}
.backText {
  color: #009da6 !important;
  display: none;
}

.fixed-widgets-avatar {
  color: #000;
  background-color: #fff;
  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;
  transition: color .3s;
  bottom: 175px;
    width: 50px;
    height: 50px;
    font-size: 22px;
    border-radius: 50%;
    text-align: center;
    display: flex;    align-items: center;
    justify-content: center;
}

.fixed-widgets {


  bottom: 102px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}


</style>